<template>
  <div :ref="`question-item-${question.id}`" :class="'question__item'">
    <div v-if="question.number" class="question__item__index">{{ question.number }}</div>
    <component :is="questionTemplate" :question="question" :editable="editable" :response="response" v-on:selectAnswer="selectAnswer"></component>
    <ExplainQuestion :explain="question.explain"  v-show="isExplain"></ExplainQuestion>
  </div>
</template>

<script>
import { APP_CONFIG } from "@/utils/constants";
import QuestionReadingBoolean   from './questions/QuestionReadingBoolean'
import QuestionReadingSelect    from './questions/QuestionReadingSelect'
import QuestionReadingText      from './questions/QuestionReadingText'
import QuestionListeningAudio  from './questions/QuestionListeningAudio'
import QuestionListeningSelect  from './questions/QuestionListeningSelect'
import QuestionListeningImage   from './questions/QuestionListeningImage'
import QuestionListeningSpell   from './questions/QuestionListeningSpell'
import QuestionWritingText      from './questions/QuestionWritingText'
import QuestionWritingContent   from './questions/QuestionWritingContent'
import QuestionWritingSort      from './questions/QuestionWritingSort'
import ExplainQuestion      from './ExplainQuestion'

export default {
  name: 'QuestionSingle',
  props: {
    question: Object,
    parent: Object,
    response: Object,
    editable: Boolean,
    isAudioPlayable: Boolean,
    isExplain: Boolean
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      audioPlayer: null,
      audioList: [],
    }
  },
  components: {
    QuestionReadingBoolean,
    QuestionReadingSelect,
    QuestionReadingText,
    QuestionListeningAudio,
    QuestionListeningSelect,
    QuestionListeningImage,
    QuestionListeningSpell,
    QuestionWritingText,
    QuestionWritingContent,
    QuestionWritingSort,
    ExplainQuestion
  },
  computed: {
    questionTemplate() {
      switch (this.question.type) {
        // Reading
        case 101:
          return 'QuestionReadingBoolean'
        
        case 102:
          return 'QuestionReadingSelect'
        
        case 106:
          return 'QuestionReadingText'
        
        // Listening
        case 151:
          return 'QuestionListeningSelect'

        case 152:
          if (this.parent && this.parent.type == 110) {
            return 'QuestionReadingText'
          }
          return 'QuestionListeningSpell'

        case 153:
          return 'QuestionListeningImage'

        case 154:
          return 'QuestionListeningImage'

        case 156:
          return 'QuestionListeningAudio'

        // Writing
        case 173:
          return 'QuestionWritingText'

        case 174:
          return 'QuestionWritingContent'

        case 176:
          return 'QuestionWritingSort'
      
        default:
          return 'QuestionReadingBoolean'
      }
    }
  },
  methods: {
    selectAnswer(dataAnswer) {
      this.$emit('selectAnswer', dataAnswer)
    },
    playAudio() {
      if (this.audioList.length) {
        let audioPath = this.audioList.shift();
        this.audioPlayer = null;
        this.audioPlayer = new Audio(this.cdnUrl + audioPath.path);

        this.audioPlayer.play();
        
        this.audioPlayer.onended = () => {
          this.playAudio();
        };
      } else {
        //
      }
    }
  },
  mounted() {
    var div = document.createElement("div")
    div.innerHTML = this.question.content

    if (!div.innerText.trim()) {
      this.question.content = null
    }

    if (this.question.audio != "0") {
      this.audioList.push({
        type: "question",
        path: this.question.audio
      });
    }

    this.question.answers.forEach(item => {
      if (item.attachment_audio != "0" && item.attachment_audio != null) {
        this.audioList.push({
          type: "question",
          path: item.attachment_audio
        });
      }
    });
    if(this.isAudioPlayable) this.playAudio();
  },
  
  beforeDestroy() {
    if (this.audioPlayer) {
      this.audioPlayer.pause();
      this.audioPlayer = null;
    }
  },
  watch: {
    isAudioPlayable: function() {
      if (this.isAudioPlayable) {
        //
      } else {
        if (this.audioPlayer) {
          this.audioPlayer.pause();
          this.audioPlayer = null;
        }
      }
    }
  }
}
</script>
